export default __webpack_public_path__ + "static/media/bopp-rolls.b08642db.jpg";